import { AbstractModel } from '../models/abstract.model';
import { IsString, IsNumber, IsDefined, IsNotEmpty } from 'class-validator';
import { PlaceInterface } from './place.interface';

export class PlaceModel extends AbstractModel implements PlaceInterface {

    @IsString()
    @IsDefined()
    @IsNotEmpty()
    public title: string = '';

    @IsString()
    public description: string = '';

    @IsString()
    @IsDefined()
    public shorthandSymbol: string = '';

    @IsString()
    public address: string = '';
}
